import $ from 'jquery';
import paroller from 'paroller.js'
$('[data-paroller-factor]').paroller({
    type: 'foreground'
});

$(".paroller-bg").paroller({
    factor: -0.35,
    // factorXl: 0.1,
    // factorLg: 0.1,
    // factorMd: 0.1,
    // factorSm: 0.1,
    // factorXs: 0.1,
    type: 'background',
    direction: 'vertical'
});